export default (lineNum) => {
  // Remove from cart via location
  // https://www.astrthelabel.com/en-bz//en-bz/products/petrova-satin-front-cutout-long-sleeve-mini-dress?variant=41654809854128 doesn't exist, auto-removed from the wishlist
  window.location.href = `${window.Shopify.routes.root}cart/change?line=${lineNum}&quantity=0`;

  // You can also do it via cartJS AJAX APIs and dynamically update the UI
  // More here https://help.shopify.com/themes/development/getting-started/using-ajax-api
};
